import Config from '../Config';

const APP_CONFIG_SET_ACTION = 'APP_CONFIG_SET';

export function appConfigDefaultState() {
  return null;
}

export async function getAppConfig(dispatch) {
  const result = await fetch(`${Config.apiGateway.INTERNAL_API_URL}/get-app-config`);
  let payload = await result.json();
  payload = {
    maintenanceMode: payload.maintenance_mode,
    appVersion: payload.app_version
  };
  dispatch({
    type: APP_CONFIG_SET_ACTION,
    payload
  });
}

export default (state = appConfigDefaultState(), action) => {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
};
